import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { SigninView } from "../features/auth/index.ts";

export const Signin: FC = () => (
  <PageContainer>
    <SigninView />
  </PageContainer>
);
